export const otherFieldsMixin = {
  computed: {
    otherFields() {
      return [
        {
          key: 'transaction_date',
          name: 'transaction_date',
          label: this.$t('costManagement.fields.transactionDate'),
          valueType: 'YYYY-MM-DD',
          type: 'date-picker',
          validation: 'required',
          format: 'DD MMMM YYYY',
        },
        {
          key: 'funds_account_source',
          name: 'funds_account_source',
          label: this.$t('costManagement.form.sourceOfFundsAccount'),
          placeholder: `${this.$t('global.form.enter')} ${this.$t(
            'costManagement.form.sourceOfFundsAccount'
          )}`,
          type: 'text',
        },
      ]
    },
  },
}
